import { render, staticRenderFns } from "./NikoIcon.vue?vue&type=template&id=50acc29d&"
import script from "./NikoIcon.vue?vue&type=script&lang=js&"
export * from "./NikoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports